module.exports = __webpack_public_path__ + "static/img/beijing.c5d48fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beijing.png
// module id = 6iXB
// module chunks = 1